import type { SupportedRepubName } from '@cx-web/domain-types';

import { type AuthProvider, authProviders } from './auth-provider';

export type TrackingConfig = {
  authProvider: AuthProvider;
  /** When true, fingerprint/nirvana client scripts are not injected into <head>. */
  skipFingerprintScripts?: boolean;
  /** When true, GTM loading is gated behind user consent (e.g., privacyOK). Default behavior loads GTM immediately. */
  usesConsentGatedGTM?: boolean;
};

export const TRACKING_CONFIGS = {
  WS: {
    authProvider: authProviders.WHOSCORED,
  },
  OC: {
    authProvider: authProviders.ODDSCHECKER,
  },
  US: {
    authProvider: authProviders.ODDSCHECKER,
  },
  GZ: {
    authProvider: authProviders.ODDSCHECKER,
    usesConsentGatedGTM: true,
    skipFingerprintScripts: true,
  },
} satisfies Record<SupportedRepubName, TrackingConfig>;
